// Page Annexes — registre des sources, formules et repères utilisés par l'app.
// Contenu = domain/annexes.ts (SOURCES), single source of truth testée.
import { ExternalLink } from 'lucide-react';
import { SOURCE_CATEGORY_LABELS, type Source, sourcesByCategory } from '@/domain';

function SourceCard({ source }: { source: Source }) {
  return (
    <div className="card" style={{ marginBottom: '0.75rem' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'baseline',
          gap: '0.75rem',
          flexWrap: 'wrap',
        }}
      >
        <span style={{ fontWeight: 650 }}>{source.title}</span>
        {source.url ? (
          <a
            href={source.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.3rem',
              fontSize: '0.85rem',
            }}
          >
            {source.reference}
            <ExternalLink size={13} aria-hidden="true" />
          </a>
        ) : (
          <span className="muted" style={{ fontSize: '0.85rem' }}>
            {source.reference}
          </span>
        )}
      </div>
      <ul
        className="muted"
        style={{ fontSize: '0.82rem', margin: '0.5rem 0 0', paddingLeft: '1.1rem' }}
      >
        {source.usedFor.map((u) => (
          <li key={u}>{u}</li>
        ))}
      </ul>
    </div>
  );
}

export function AnnexesPage() {
  const grouped = sourcesByCategory();
  return (
    <>
      <div className="page-header">
        <div>
          <h1>Annexes</h1>
          <p>
            Toutes les sources, formules et repères qui pilotent l'app. Rien n'est inventé : chaque
            valeur porte sa source, et la dernière section liste ce qu'on refuse de projeter faute
            de source fiable.
          </p>
        </div>
      </div>

      {Object.entries(grouped).map(([category, sources]) =>
        sources.length === 0 ? null : (
          <section key={category} style={{ marginBottom: '1.5rem' }}>
            <h2 style={{ fontSize: '1.05rem', marginBottom: '0.75rem' }}>
              {SOURCE_CATEGORY_LABELS[category as keyof typeof SOURCE_CATEGORY_LABELS]}
            </h2>
            {sources.map((s) => (
              <SourceCard key={s.id} source={s} />
            ))}
          </section>
        ),
      )}
    </>
  );
}
